import Axios from 'axios'

const UserStore = {
    namespaced: true,
    state: {
        status: '',
        jwt: localStorage.getItem('jwt') || '',
        user: {},
        userSettings: {},
        stats: {}
    },
    mutations: {
        auth_request(state){
            state.status = 'loading'
        },
        auth_success(state, jwt, user){
            state.status = 'success'
            state.jwt = jwt
            state.user = user
        },
        auth_error(state){
            state.status = 'error'
        },
        logout(state){
            state.status = ''
            state.jwt = ''
            state.user = {}
        },
        setSettings(state, settings){
            state.userSettings = settings
        },
        setStats(state, stats){
            state.stats = stats
        }
    },
    actions: {
        login: login,
        logout: logout,
        updateProfile: updateProfile,
        getSettings: getSettings,
        getStats: getStats
    }
}

function getSettings(context){
    return Axios.get(this.sightApiBaseUrl + "profile/edit").then(resp => {
        context.commit('setSettings', resp.data)
        localStorage.setItem('user_settings', JSON.stringify(resp.data))
    }).catch(err => {
        console.log("UsersStore/GetSettings error", err)
    })
}

function updateProfile(context, userData){
    return Axios.put(this.sightApiBaseUrl + "profile", {user: userData}).then(resp => {
        const account = resp.data
        localStorage.setItem('account', JSON.stringify(account))
    }).catch(err => {
        console.log("UsersStore/UpdateProfile error", err)
    })
}

function logout({commit}){
    localStorage.removeItem('jwt')
    localStorage.removeItem('user')
    commit('logout')
}

function getStats(context){
    return Axios.get(this.sightApiBaseUrl + "profile/get_stats").then(resp => {
        context.commit('setStats', resp.data)
    }).catch(err => {
        console.log("UsersStore/getStats error", err)
    })
}

function login({commit}, user){

    user.client_id = process.env.VUE_APP_AXIOS_API_ID
    user.api_secret = process.env.VUE_APP_AXIOS_API_SECRET
    user.origin_app = "sight"

    commit('auth_request')
    return Axios.post(`iapp_api/${process.env.VUE_APP_AXIOS_API_ID}/v1/auth/`, user).then(resp => {

        const jwt = resp.data.jwt
        const user = resp.data.user
        const account = resp.data.account

        localStorage.setItem('jwt', jwt)
        localStorage.setItem('account', JSON.stringify(account))
        Axios.defaults.headers.common['Authorization'] = "Bearer " + jwt
        commit('auth_success', jwt, user)

        return resp

    }).catch(err => {
        commit('auth_error')
        localStorage.removeItem('jwt')
        localStorage.removeItem('user')
        return err
    })

}

export default UserStore